<div class="audit-log-events-filters">
  <div class="audit-log-events-filters-row">
    <app-search-box
      class="filters-search"
      [placeholder]="'userManagementPage.auditLogsPage.filters.search' | labelsProvider"
      [startingValue]="pageFilters.search.getFilterValue()"
      (textOnSelection)="searchSubmitted($event)"
      [syncValidators]="searchValidators"
    >
    </app-search-box>

    <app-date-picker
      class="filters-date-picker"
      (dateOnSelection)="fromDateSelected($event)"
      label="tableActionsAndFilters.fromDate"
      [startingValue]="pageFilters.fromDate.getFilterValue()"
      [newValueTriggered$]="fromDateNewValue"
      [maxDate]="pageFilters.toDate.getFilterValue()"
    >
    </app-date-picker>

    <app-date-picker
      class="filters-date-picker"
      (dateOnSelection)="toDateSelected($event)"
      label="tableActionsAndFilters.toDate"
      [startingValue]="pageFilters.toDate.getFilterValue()"
      [newValueTriggered$]="toDateNewValue"
      [minDate]="pageFilters.fromDate.getFilterValue()"
    >
    </app-date-picker>
  </div>
  <app-view-filters-multi-select [pageFilters]="pageFilters"></app-view-filters-multi-select>
</div>
